/**
 * remove-initial-view-class
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */
"use strict";

export default sb => {
    sb.find("#initial_view").removeClass("initial_view");
}
